import React from "react";
import "./DialogFooter.scss";

export const DialogFooter: React.FC = ({ children }) => (
  <div className="dialog-footer">{children}</div>
);
